
export default {
    categoria: {},
    categorias: []
}